import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('dashboard-birthdays', storeModule.createStoreModule('dashboard-birthdays'))
